var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1.5V14.5C13.5 14.6326 13.4473 14.7598 13.3536 14.8536C13.2598 14.9473 13.1326 15 13 15H3C2.86739 15 2.74021 14.9473 2.64645 14.8536C2.55268 14.7598 2.5 14.6326 2.5 14.5V13.5H3.5V14H12.5V2H3.5V3.5H2.5V1.5C2.5 1.36739 2.55268 1.24021 2.64645 1.14645C2.74021 1.05268 2.86739 1 3 1H13C13.1326 1 13.2598 1.05268 13.3536 1.14645C13.4473 1.24021 13.5 1.36739 13.5 1.5ZM6.145 10.145L6.855 10.855L9.355 8.355C9.40186 8.30852 9.43906 8.25322 9.46445 8.19229C9.48983 8.13136 9.5029 8.06601 9.5029 8C9.5029 7.93399 9.48983 7.86864 9.46445 7.80771C9.43906 7.74678 9.40186 7.69148 9.355 7.645L6.855 5.145L6.145 5.855L7.795 7.5H2.5V8.5H7.795L6.145 10.145Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/loginIcon.906b5cbf68a8245a951dc8590a13e029.svg";
export { ForwardRef as ReactComponent };